var exports = {
  "K": "shared.module__icon___T1NjbH",
  "B": "shared.module__iconSmall___T1NjbH",
};

module.exports = exports;
